<template>
  <div style="display: flex;flex-direction: row;justify-content: center;">
    <div id="myCharts" ref="myCharts" style="width: 500px; height: 350px;"></div>
  </div>
</template>

<script>
import reportService from '@/service/report'

let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: 'RegisterInfo',
  data () {
    return {
      registerInfo: [],
      xData: [],
      data: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.$indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      reportService.getRegisterInfo()
        .then(res => {
          if (res.data.result_code === 200) {
            this.registerInfo = res.data.data
            this.data = this.registerInfo.map(m => m.register_num)
            this.xData = this.registerInfo.map(m => m.month_day)
            let chart = echarts.init(document.getElementById('myCharts'), '', {
              renderer: 'svg'
            })
            chart.setOption({
              xAxis: {
                type: 'category',
                data: this.xData
              },
              yAxis: {
                type: 'value'
              },
              series: [{
                data: this.data,
                type: 'line'
              }]
            })
          } else {
            this.$messagebox.alert({
              message: '获取数据失败！',
              title: '提示信息',
              showCancelButton: false
            })
          }
        })
        .catch(res => {
          console.log(res)
        })
        .finally(() => this.$indicator.close())
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/RegisterInfo.vue